import { render, staticRenderFns } from "./CheckoutPaymentCheck.vue?vue&type=template&id=08c9bbab&scoped=true&"
import script from "./CheckoutPaymentCheck.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c9bbab",
  null
  
)

export default component.exports